/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { useState } from 'react'
import Styles from './styles.module.sass'
import ModalNickname from './components/ModalNickname'
import { formLeosToZetons } from '@/utils/general'
import ModalAuth0AccessToken from './components/ModalAuth0AccessToken'
import CardWithTitle from '@/components/cards/defaults/CardWithTitle'
import { Button } from '@chakra-ui/react'

const UserInfo = ({
  altImage,
  auth0UserId,
  balances,
  className = '',
  email,
  getAccessToken,
  name,
  nickname,
  nicknameAction = 'Set',
  organizationName,
  updateNickname,
  urlImage,
  zetoniumUserId
}) => {
  const [showModal, setShowModal] = useState(false)
  const silverZetons = formLeosToZetons(balances.silver_leos, false)

  return (
    <CardWithTitle
      title="User Info"
      className={className}
    >
      <div className={Styles.panelContainer}>
        <div className="mr-xs">
          <figure className="image is-48x48">
            <img src={urlImage} alt={altImage} />
          </figure>
        </div>
        <div className={Styles.userInfoContainer}>
          <p className={Styles.heading3}>{ name }</p>
          <p className="mb-xs">{ email }</p>
          { organizationName &&
            <p>Organization: { organizationName }</p>
          }
          { nickname &&
            <p className="mb-xs">User Nickname: { nickname }</p>
          }
           <p className="mb-xs">Role: Authenticated</p>
          <div>
            <p className="mb-xs">Żetonium User ID: { zetoniumUserId }</p>
          </div>
          <div>
            <p className="mb-xs">Credit Balance:  ${silverZetons} Silver Żetons</p>
          </div>
          <div className="mt-xs">
            <div className="mb-2">
              <Button onClick={ () => setShowModal(true) }>
                set Nickname
              </Button>
            </div>
            <ModalAuth0AccessToken getAccessToken={getAccessToken} />
          </div>
        </div>
      </div>
      { showModal &&
        <ModalNickname
          action={nicknameAction}
          auth0UserId={auth0UserId}
          nickname={nickname}
          zetoniumUserId={zetoniumUserId}
          onClose={() => setShowModal(false) }
          updateNickname={updateNickname}
        />
      }
  </CardWithTitle>
  )
}

export default UserInfo
